import { Typography } from "@mui/material";
import currency from "currency.js";
import React from "react";

export default function CustomerSpend(props) {
  const { customer, hasManagerAccess } = props;

  let orderSummary = "";
  if (customer.orders?.length === 0) {
    orderSummary = "No Orders Yet";
  } else {
    orderSummary = `${customer.orders.length} ORDERS`;
  }

  if (hasManagerAccess) {
    orderSummary += ` • ${currency(
      customer.orders.reduce(
        (acc, o) => +acc + +(o.src === "mkt" ? o.payment.bakerTotal : o.payment.total),
        0
      ),
      { precision: 0 }
    ).format()}
            SPEND`;
  }

  return (
    <Typography variant="overline" color="textSecondary">
      {orderSummary}
    </Typography>
  );
}
